// Lightweight inline-SVG replacements for the handful of Font Awesome glyphs
// this site actually used. Loading the full fontawesome-free package (CSS +
// 3 webfont files) render-blocked every page for these ~7 icons.

export const ChevronRightIcon = (props) => (
  <svg
    viewBox="0 0 320 512"
    width="0.85em"
    height="0.85em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M285.5 273.4l-192 192c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L242.7 256 59.6 72.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l192 192c9.4 9.5 9.4 24.7 0 33.9z" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M173.9 439.4l-166.4-166.4c-9.7-9.7-9.7-25.6 0-35.4l35.4-35.4c9.7-9.7 25.6-9.7 35.4 0L192 314.9 415.7 91.1c9.7-9.7 25.6-9.7 35.4 0l35.4 35.4c9.7 9.7 9.7 25.6 0 35.4l-277.2 277.5c-9.8 9.7-25.6 9.7-35.4 0z" />
  </svg>
);

export const TimesIcon = (props) => (
  <svg
    viewBox="0 0 352 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.4c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z" />
  </svg>
);

export const CircleNotchIcon = (props) => (
  <svg
    className="icon-spin"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M456.5 296.4c-11.5-4.8-24.7.7-29.5 12.2-8.1 19.4-20 37-35.4 52.4-15.2 15.2-33 27.2-52.4 35.4-19.4 8.2-40 12.3-61.2 12.3s-41.8-4.1-61.2-12.3c-19.4-8.1-37-20-52.4-35.4-15.2-15.2-27.2-33-35.4-52.4-8.2-19.4-12.3-40-12.3-61.2s4.1-41.8 12.3-61.2c8.1-19.4 20-37 35.4-52.4 15.2-15.2 33-27.2 52.4-35.4 19.4-8.2 40-12.3 61.2-12.3 15.1 0 29.9 2.1 44.1 6.2 8.4 2.4 17.4-1.2 21.6-8.9l14.9-27.3c5-9.1 1.1-20.5-8.6-24.6C332 12.6 302.4 8 272 8 146.6 8 44.6 106.4 40.6 231.8c-4.1 128.9 100.3 235.7 229.4 235.7 108.6 0 199.5-75.3 223.9-176.6 3.3-13.7-4.3-27.7-17.4-33.5z" />
  </svg>
);

export const LinkedinIcon = (props) => (
  <svg
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340c-29.7 0-53.84-24.14-53.84-53.9C0 24.14 24.14 0 53.84 0s53.84 24.14 53.84 53.84c0 29.76-24.14 54.16-53.84 54.16zM447.9 448h-92.68V302.4c0-34.7-.7-79.3-48.29-79.3-48.3 0-55.7 37.7-55.7 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
  </svg>
);

export const TwitterIcon = (props) => (
  <svg
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M459.4 151.7c.3 4.5.3 9.1.3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103v-1.3c14 7.8 30.3 12.7 47.4 13.3-28.3-18.9-46.8-51.1-46.8-87.6 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.1z" />
  </svg>
);

export const InstagramIcon = (props) => (
  <svg
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
  </svg>
);
